module.exports = __webpack_public_path__ + "img/pronaht-logo-simple-white.19ad9d0f.svg";